import React, { useState } from 'react';
import { Card, Button, Form, ListGroup } from 'react-bootstrap';

const ForoDiscusion = () => {
  // Simulación de temas y preguntas del foro
  const temasIniciales = [
    {
      id: 1,
      titulo: 'Lección 1: Introducción a Álgebra',
      preguntas: [
        {
          id: 1,
          usuario: {
            nombre: 'Estudiante1',
            avatar: 'https://via.placeholder.com/56',
            descripcion: 'Estudiante de 4to grado apasionado por las matemáticas.',
          },
          pregunta: '¿Cómo resuelvo una ecuación cuadrática?',
          respuestas: [
            {
              usuario: {
                nombre: 'Profesor',
                avatar: 'https://via.placeholder.com/56',
                descripcion: 'Profesor de matemáticas con 10 años de experiencia.',
              },
              respuesta: 'Para resolver una ecuación cuadrática puedes utilizar la fórmula cuadrática.',
            },
          ],
        },
      ],
    },
    {
      id: 2,
      titulo: 'Lección 2: Geometría Básica',
      preguntas: [
        {
          id: 1,
          usuario: {
            nombre: 'Estudiante2',
            avatar: 'https://via.placeholder.com/56',
            descripcion: 'Estudiante interesado en ciencias naturales.',
          },
          pregunta: '¿Cuál es la fórmula para el área de un triángulo?',
          respuestas: [
            {
              usuario: {
                nombre: 'Profesor',
                avatar: 'https://via.placeholder.com/56',
                descripcion: 'Profesor de ciencias naturales y geometría.',
              },
              respuesta: 'La fórmula es (base * altura) / 2.',
            },
          ],
        },
      ],
    },
  ];

  const [temas, setTemas] = useState(temasIniciales);
  const [preguntaNueva, setPreguntaNueva] = useState('');
  const [temaSeleccionado, setTemaSeleccionado] = useState(temas[0]);
  const [perfilSeleccionado, setPerfilSeleccionado] = useState(temaSeleccionado.preguntas[0].usuario);

  // Manejar publicación de una nueva pregunta
  const agregarPregunta = (e) => {
    e.preventDefault();
    if (preguntaNueva.trim()) {
      const nuevaPregunta = {
        id: temaSeleccionado.preguntas.length + 1,
        usuario: {
          nombre: 'Estudiante3',
          avatar: 'https://via.placeholder.com/56',
          descripcion: 'Nuevo estudiante en la lección de álgebra.',
        },
        pregunta: preguntaNueva,
        respuestas: [],
      };

      const temasActualizados = temas.map((tema) =>
        tema.id === temaSeleccionado.id
          ? { ...tema, preguntas: [...tema.preguntas, nuevaPregunta] }
          : tema
      );

      setTemas(temasActualizados);
      setPreguntaNueva('');
    }
  };

  // Manejar el envío de una respuesta
  const agregarRespuesta = (idTema, idPregunta, nuevaRespuesta) => {
    const temasActualizados = temas.map((tema) =>
      tema.id === idTema
        ? {
            ...tema,
            preguntas: tema.preguntas.map((pregunta) =>
              pregunta.id === idPregunta
                ? {
                    ...pregunta,
                    respuestas: [...pregunta.respuestas, { 
                      usuario: {
                        nombre: 'Profesor', 
                        avatar: 'https://via.placeholder.com/56', 
                        descripcion: 'Profesor experimentado en matemáticas.'
                      }, 
                      respuesta: nuevaRespuesta 
                    }],
                  }
                : pregunta
            ),
          }
        : tema
    );
    setTemas(temasActualizados);
  };

  const seleccionarPerfil = (usuario) => {
    setPerfilSeleccionado(usuario);
  };

  return (
    <div className="container-fluid p-0">
      <h1 className="h3 mb-3">Foro de Discusión</h1>

      <div className="row">
        {/* Lista de Temas del Foro */}
        <div className="col-12 col-lg-8">
          <Card className="mb-4">
            <Card.Header>
              <h5>{temaSeleccionado.titulo}</h5>
            </Card.Header>
            <Card.Body>
              <h6>Preguntas:</h6>
              {temaSeleccionado.preguntas.map((pregunta) => (
                <Card key={pregunta.id} className="mb-3">
                  <Card.Body>
                    <div className="d-flex align-items-start">
                      <img
                        src={pregunta.usuario.avatar}
                        width="56"
                        height="56"
                        className="rounded-circle me-3"
                        alt={pregunta.usuario.nombre}
                      />
                      <div className="flex-grow-1">
                        <strong>{pregunta.usuario.nombre}</strong> pregunta:
                        <p>{pregunta.pregunta}</p>
                        <Button
                          variant="link"
                          onClick={() => seleccionarPerfil(pregunta.usuario)}
                        >
                          Ver perfil
                        </Button>

                        {/* Respuestas */}
                        <h6>Respuestas:</h6>
                        {pregunta.respuestas.map((respuesta, index) => (
                          <div key={index} className="d-flex align-items-start mb-2">
                            <img
                              src={respuesta.usuario.avatar}
                              width="36"
                              height="36"
                              className="rounded-circle me-2"
                              alt={respuesta.usuario.nombre}
                            />
                            <div className="flex-grow-1">
                              <strong>{respuesta.usuario.nombre}</strong>:
                              <p>{respuesta.respuesta}</p>
                            </div>
                          </div>
                        ))}

                        {/* Formulario para agregar una respuesta */}
                        <Form
                          onSubmit={(e) => {
                            e.preventDefault();
                            agregarRespuesta(temaSeleccionado.id, pregunta.id, e.target.elements.nuevaRespuesta.value);
                            e.target.elements.nuevaRespuesta.value = '';
                          }}
                        >
                          <Form.Group>
                            <Form.Control
                              type="text"
                              name="nuevaRespuesta"
                              placeholder="Escribe tu respuesta"
                              required
                            />
                          </Form.Group>
                          <Button type="submit" variant="primary" className="mt-2">
                            Responder
                          </Button>
                        </Form>
                      </div>
                    </div>
                  </Card.Body>
                </Card>
              ))}

              {/* Formulario para agregar nueva pregunta */}
              <Form onSubmit={agregarPregunta}>
                <Form.Group>
                  <Form.Label>Nueva Pregunta:</Form.Label>
                  <Form.Control
                    type="text"
                    value={preguntaNueva}
                    onChange={(e) => setPreguntaNueva(e.target.value)}
                    placeholder="Escribe tu pregunta"
                    required
                  />
                </Form.Group>
                <Button type="submit" variant="primary" className="mt-3">
                  Publicar Pregunta
                </Button>
              </Form>
            </Card.Body>
          </Card>
        </div>

        {/* Perfil de la persona */}
        <div className="col-12 col-lg-4">
          <Card className="mb-4 text-center">
            <Card.Body>
              <img
                src={perfilSeleccionado.avatar}
                alt={perfilSeleccionado.nombre}
                className="img-fluid rounded-circle mb-2"
                width="128"
                height="128"
              />
              <h4 className="card-title mb-0">{perfilSeleccionado.nombre}</h4>
              <div className="text-muted mb-2">Estudiante</div>
              <p>{perfilSeleccionado.descripcion}</p>
            </Card.Body>
          </Card>

          <ListGroup>
            <ListGroup.Item><strong>Email:</strong> {perfilSeleccionado.nombre.toLowerCase()}@example.com</ListGroup.Item>
            <ListGroup.Item><strong>Teléfono:</strong> +123 456 7890</ListGroup.Item>
          </ListGroup>
        </div>
      </div>
    </div>
  );
};

export default ForoDiscusion;
